import { render, staticRenderFns } from "./article-box.vue?vue&type=template&id=1b0a7fde&scoped=true&"
import script from "./article-box.vue?vue&type=script&lang=js&"
export * from "./article-box.vue?vue&type=script&lang=js&"
import style0 from "./article-box.vue?vue&type=style&index=0&id=1b0a7fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a7fde",
  null
  
)

export default component.exports